(() => {
  const HEADING_SELECTOR = 'h1, h2, h3, h4, h5, h6';
  const SKIP_SELECTOR = 'script, style, svg, path, noscript, template, [hidden]';
  const CONTROL_SELECTOR = 'input, select, textarea, button';
  const DATA_ATTRIBUTE = 'data-fd-font-adjusted';
  const originalInlineSizes = new WeakMap();
  let resizeTimer = null;

  const hasDirectText = (element) => Array.from(element.childNodes).some((node) => (
    node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== ''
  ));

  const restoreAdjustedSizes = () => {
    document.querySelectorAll(`[${DATA_ATTRIBUTE}]`).forEach((element) => {
      const original = originalInlineSizes.get(element);
      if (original) {
        element.style.setProperty('font-size', original.value, original.priority);
      } else {
        element.style.removeProperty('font-size');
      }
      element.removeAttribute(DATA_ATTRIBUTE);
    });
  };

  const adjustTextSizes = () => {
    restoreAdjustedSizes();

    const candidates = Array.from(document.body.querySelectorAll('*')).filter((element) => {
      if (element.matches(SKIP_SELECTOR) || element.closest(HEADING_SELECTOR)) return false;
      return element.matches(CONTROL_SELECTOR) || hasDirectText(element);
    });

    const candidateSet = new Set(candidates);
    candidates.forEach((element) => {
      let ancestor = element.parentElement;
      while (ancestor && ancestor !== document.body) {
        if (candidateSet.has(ancestor)) return;
        ancestor = ancestor.parentElement;
      }

      const computedSize = Number.parseFloat(window.getComputedStyle(element).fontSize);
      if (!Number.isFinite(computedSize)) return;

      originalInlineSizes.set(element, {
        value: element.style.getPropertyValue('font-size'),
        priority: element.style.getPropertyPriority('font-size')
      });
      element.style.setProperty('font-size', `${computedSize + 2}px`, 'important');
      element.setAttribute(DATA_ATTRIBUTE, 'true');
    });
  };

  const scheduleAdjustment = () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(adjustTextSizes, 120);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', adjustTextSizes, { once: true });
  } else {
    adjustTextSizes();
  }

  window.addEventListener('resize', scheduleAdjustment);
  document.addEventListener('shopify:section:load', scheduleAdjustment);
  document.addEventListener('shopify:section:unload', scheduleAdjustment);
})();
